import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../components/AppShell";
import { ChevronLeft } from "lucide-react";

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="wizard-shell">
      <div className="wizard-frame fade-in">
        <header className="px-5 py-3 border-b border-slate-100 flex items-center gap-2">
          <button onClick={() => navigate(-1)}
            className="h-9 w-9 rounded-full hover:bg-slate-100 flex items-center justify-center"
            data-testid="btn-privacy-back" aria-label="Volver">
            <ChevronLeft className="w-5 h-5 text-slate-700" />
          </button>
          <Logo size={28} withWordmark />
        </header>
        <main className="flex-1 px-5 py-6 fade-in overflow-auto">
          <h1 className="text-2xl font-[Outfit] font-extrabold tracking-tight text-slate-900">
            Política de Privacidad
          </h1>
          <p className="text-xs text-slate-500 mt-1">
            En Línea Madrid · Última actualización: 2026
          </p>

          <div className="mt-5 space-y-5 text-sm text-slate-700 leading-relaxed">
            <Section title="1. Responsable del tratamiento">
              <p>
                <strong>En Línea Madrid</strong> es responsable del tratamiento de tus datos
                personales. Para cualquier consulta puedes contactarnos en{" "}
                <a href="mailto:enlineamadrid@gmail.com" className="text-[var(--el-red)] underline">
                  enlineamadrid@gmail.com
                </a>.
              </p>
            </Section>

            <Section title="2. Datos que recogemos">
              <p>Recogemos exclusivamente los datos que tú nos facilitas a través del formulario:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Nombre y apellidos</li>
                <li>Email</li>
                <li>Teléfono (opcional)</li>
                <li>Información sobre tu negocio (tipo, estilo, objetivos)</li>
                <li>Datos de pago tratados directamente por Stripe (no almacenamos números de tarjeta)</li>
              </ul>
            </Section>

            <Section title="3. Finalidad">
              <p>Utilizamos tus datos para:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Crear y entregar tu prototipo y proyecto digital</li>
                <li>Enviarte comunicaciones relativas a tu proyecto</li>
                <li>Gestionar pagos y facturación</li>
                <li>Cumplir con obligaciones legales</li>
              </ul>
            </Section>

            <Section title="4. Base legal">
              <p>
                El tratamiento se basa en tu consentimiento expreso al aceptar esta política
                durante el onboarding, y en la ejecución del contrato cuando contratas un plan.
              </p>
            </Section>

            <Section title="5. Tus derechos">
              <p>Puedes ejercer en cualquier momento los derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a{" "}
                <a href="mailto:enlineamadrid@gmail.com" className="text-[var(--el-red)] underline">
                  enlineamadrid@gmail.com
                </a>.
              </p>
            </Section>

            <Section title="6. Conservación">
              <p>Conservamos tus datos durante el tiempo necesario para la prestación del servicio y hasta que solicites su eliminación, salvo obligación legal.</p>
            </Section>

            <Section title="7. Terceros">
              <p>
                Compartimos datos únicamente con proveedores estrictamente necesarios:
                Stripe (pagos), Resend (envío de email) y servicios de hosting. Todos cumplen
                con la normativa europea de protección de datos.
              </p>
            </Section>

            <Section title="8. Cookies">
              <p>
                Únicamente utilizamos almacenamiento local técnico para mantener tu sesión.
                No empleamos cookies publicitarias ni de tracking de terceros.
              </p>
            </Section>
          </div>
        </main>
      </div>
    </div>
  );
}

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-[Outfit] font-bold text-slate-900 text-base mb-1.5">{title}</h2>
    {children}
  </section>
);
